var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"margin-top":"85px"},attrs:{"id":"app"}},[(this.user.loggedIn)?_c('navbar',{staticStyle:{"position":"fixed","top":"0","z-index":"1000","width":"100%"}}):_vm._e(),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }